export default __webpack_public_path__ + "static/data-9e43898a2144fdf534599e8753383ea1.svg";